import { jsx as _jsx } from "react/jsx-runtime";
import { createTheme, ThemeProvider as MUIThemeProvider, } from '@mui/material/styles';
import { deepmerge } from '@mui/utils';
import { getV2ThemeOptions } from './get-v2-theme-options';
/**
 * Nested theme provider for redesigned ("v2") page subtrees. It layers the v2
 * token deltas (see get-v2-theme-options.ts) over the surrounding v1 theme:
 * everything is inherited from the outer theme and only the v2 deltas override.
 *
 * It deliberately does NOT render `CssBaseline` — the outer (v1) `ThemeProvider`
 * already did; a second baseline would duplicate global styles. Wrap only the
 * page/region that should adopt the redesign; the rest of the app stays on v1.
 */
export const V2ThemeProvider = ({ children }) => (_jsx(MUIThemeProvider, { theme: (outer) => createTheme(deepmerge(outer, getV2ThemeOptions())), children: children }));
